'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { isValidElement } from 'react';
import styled from 'styled-components';
import { getComponentPropType } from '../utils/propTypes/componentProp';
import createLazyPropType from '../utils/propTypes/createLazyPropType';
import H2 from '../elements/headings/H2';
import lazyEval from '../utils/lazyEval';
import UIIllustration from '../image/UIIllustration';
import UISection from '../section/UISection';
import { getIllustrationNamePropType } from '../utils/propTypes/illustrationName';
const MessageOuter = styled(UISection).withConfig({
  displayName: "UIResultsMessage__MessageOuter",
  componentId: "cj4z0l-0"
})(["text-align:center;"]);
const MessageImage = styled(UIIllustration).withConfig({
  displayName: "UIResultsMessage__MessageImage",
  componentId: "cj4z0l-1"
})(["margin-bottom:40px;"]);
const defaultIllustrationProps = {
  width: 175
};

const renderTitle = title => {
  if (!title) return null;
  if ( /*#__PURE__*/isValidElement(title)) return title;
  return /*#__PURE__*/_jsx(H2, {
    children: lazyEval(title)
  });
};

const renderImage = (illustration, illustrationProps, Image) => {
  if (!illustration && !Image) return null;
  return /*#__PURE__*/_jsx(Image, Object.assign({
    name: illustration
  }, defaultIllustrationProps, {}, illustrationProps));
};

export default function UIResultsMessage(props) {
  const {
    Body,
    children,
    illustration,
    illustrationProps,
    Image,
    title
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["Body", "children", "illustration", "illustrationProps", "Image", "title"]);

  return /*#__PURE__*/_jsxs(MessageOuter, Object.assign({}, rest, {
    role: "alert",
    use: "island",
    children: [renderImage(illustration, illustrationProps, Image), renderTitle(title), /*#__PURE__*/_jsx(Body, {
      children: children
    })]
  }));
}
UIResultsMessage.propTypes = {
  Body: PropTypes.elementType,
  children: PropTypes.node,
  illustration: getIllustrationNamePropType(),
  illustrationProps: PropTypes.object,
  Image: getComponentPropType(UIIllustration),
  title: createLazyPropType(PropTypes.node)
};
UIResultsMessage.defaultProps = {
  Body: 'div',
  Image: MessageImage,
  illustrationProps: defaultIllustrationProps
};
UIResultsMessage.displayName = 'UIResultsMessage';